import Grid from "@mui/material/Grid2";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import DataContainer from "../../../../Utilities/DataContainer";
import RenderSelectField from "../../../../Utilities/Forms/RenderSelectField";
import ValidatedSelectElement from "../../../../Utilities/Forms/ValidatedSelectElement";
import ValidatedTextField from "../../../../Utilities/Forms/ValidatedTextField";
import monthDropdown from "../../../../Utilities/Constants/MonthDropdown";
import shiftPatternDropdown from "../../../../Utilities/Constants/ShifttPatternDropdown";
import DropDownViewModel from "../../../../Utilities/ViewModels/DropDownViewModel";
import yesNoDropdown from "../../../../Utilities/Constants/YesNoDropdown";

interface IProps {
    typeDropdown: DropDownViewModel[] | [];
}
export default function MonitoringReportImplementation({ typeDropdown }: IProps) {

    return (
        <Grid container>
            <Grid size={6}>
                <DataContainer title={"Travel Plan Type & Co-ordination"}>
                    <Stack spacing={1}>
                        <RenderSelectField label={"Travel Plan Type"} options={typeDropdown} name={"travelPlanType"} readOnly={true} />
                        <RenderSelectField label={"Is there a Travel Plan co-ordinator - a member of staff whose job it is to manage the implementation of the Travel Plan"} options={yesNoDropdown} name={"travelPlanCoordinator"} readOnly={true} />
                        <RenderSelectField label={"If YES to the above, do they work on the Travel Plan full time or part time?"} options={shiftPatternDropdown} name={"coordinatorShiftType"} readOnly={true} />
                    </Stack>
                </DataContainer>
            </Grid>
            <Grid size={6}>
                <DataContainer title={"Implementation of Travel Plan"}>
                    <Grid size={12}>
                        <Typography variant={"body2"}>Date of Travel Plan Implementation</Typography>
                    </Grid>
                    <Stack direction="row" spacing={1}>
                        <Grid size={6}>
                            <ValidatedSelectElement name={'monthImplemeted'} options={monthDropdown} readOnly={true} />
                        </Grid>
                        <Grid size={6}>
                            <ValidatedTextField name={'yearImplemeted'} readOnly={true} />
                        </Grid>
                    </Stack>
                </DataContainer>
            </Grid>
        </Grid>
    );
}